import { trackUnstruct } from 'components/SnowplowTracker/SnowplowTracker';
import { trackGoogleTagManagerEvent as gtmPush } from 'components/GoogleTagManager/GoogleTagManager';

let userId;
let deviceType;
export const setUserId = id => (userId = id);
export const setDeviceType = type => (deviceType = type);

export const ec = (...args) => {
  trackUnstruct(args.length >= 1 && args[0] ? args[0] : '', {
    app_platform: 'web',
    ...(args.length >= 2 && args[1] ? args[1] : {}),
    ...(userId ? { user_id: String(userId) } : {}),
    ...(deviceType ? { device_type: deviceType } : {}),
  });
};

export const ga = (eventCategory, eventAction, ...args) => {
  const [eventLabel, eventValue, options] = args;
  gtmPush({
    event: 'gaEvent',
    eventCategory,
    eventAction,
    eventLabel,
    eventValue: eventValue || 0,
    eventNI: (options && options.nonInteraction) || false,
  });

  trackUnstruct(`${eventCategory} - ${eventAction}`, {
    app_platform: 'web',
    ...(args.length >= 1 && eventLabel ? { eventLabel } : {}),
    ...(args.length >= 2 && eventValue ? { eventValue } : {}),
    ...(args.length >= 3 && options && options.nonInteraction ? { nonInteraction: true } : {}),
    ...(userId ? { user_id: String(userId) } : {}),
  });
};
